import * as Yup from 'yup';

const requiredText = () => Yup.string().trim().required('Required');

export const amendmentMotorValidationSchema = (lineCode: string) =>
  Yup.object({
    motorDetails: Yup.object({
      nameOnLicenseEN: requiredText(),
      nameOnLicenseAR: requiredText(),
      vignetteCode:
        lineCode === '50' ? requiredText() : Yup.string().trim().nullable(),
      vignette:
        lineCode === '50' ? requiredText() : Yup.string().trim().nullable(),
      plateCode: Yup.string().trim().notRequired(),
      plateNumber: Yup.string()
        .trim()
        .transform((value) => (value === '' ? undefined : value))
        .notRequired()
        .min(2, 'Invalid Plate Number')
        .max(300, 'Invalid Plate Number'),
      usage: requiredText(),
      body: requiredText(),
      engineType: requiredText(),
      make: requiredText(),
      model: requiredText(),
      yearOfMake: Yup.number()
        .typeError('Invalid Year of Make')
        .required('Required')
        .min(1900, 'Invalid Year of Make')
        .max(2100, 'Invalid Year of Make'),
      engine: requiredText(),
      weight: Yup.number()
        .typeError('Invalid Weight')
        .when('body', {
          is: (body: string) => ['VAN', 'PICKUP', 'F_TANKER'].includes(body),
          then: (schema) =>
            schema
              .required('Required')
              .min(0.001, 'Invalid Weight')
              .max(9999, 'Invalid Weight'),
          otherwise: (schema) => schema.nullable().notRequired()
        }),
      engineSize: Yup.number()
        .typeError('Invalid Engine Size')
        .when('body', {
          is: 'MOTORCYCLE',
          then: (schema) =>
            schema
              .required('Required')
              .min(0.001, 'Invalid Engine Size')
              .max(99999, 'Invalid Engine Size'),
          otherwise: (schema) => schema.nullable().notRequired()
        }),
      seatingCapacity: Yup.string()
        .trim()
        .required('Required')
        .min(1, 'Invalid Seats')
        .max(2, 'Invalid Seats'),
      chassis: requiredText()
        .min(2, 'Invalid Chassis')
        .max(50, 'Invalid Chassis'),
      horsePower: requiredText(),
      carValue:
        lineCode === '51'
          ? Yup.number()
              .typeError('Invalid Car Value')
              .required('Required')
              .min(0.001, 'Invalid Car Value')
          : Yup.number().nullable().notRequired()
    })
  });
